<template>
  <div class="auth-block">
    <div class="auth-block__main_title">
      <div class="auth-block__main_title__title">
        ДИЛЕРСКИЙ ПОРТАЛ
      </div>
      <div class="auth-block__main_title__text">
        Размещение заказов на автомобили ГК "СОЛЛЕРС"
      </div>
    </div>

    <div class="auth-block__content">
      <div class="auth-screen">
        <div class="auth-screen__top">
          <div class="auth-screen__top__image-block">
            <img
              class="auth-screen__top__image-block__image"
              src="@/assets/logo.png"
              alt="Sollers Ford SVO"
              width="220"
              height="66"
            >
          </div>
          <div class="auth-screen__top__image-block">
            <img
              class="auth-screen__top__image-block__image"
              src="@/assets/loginImage.png"
              alt="Sollers Ford SVO"
              height="80"
            >
          </div>
        </div>
        <div class="lost-block">
          <div
            v-if="isResetCodeVerified === null && processing"
            class="alert alert-info py-4 d-flex align-items-center justify-content-center"
          >
            <b class="mr-2">Сбрасываем пароль...</b>
            <b-spinner type="grow" />
          </div>
          <div
            v-else-if="isResetCodeVerified && user"
            class="alert alert-info pt-4 pb-4 text-center"
          >
            <b>Пользователь: {{ user.email }}</b><br>
            <b>Пароль успешно сброшен!</b>
          </div>
          <div
            v-else-if="isResetCodeVerified === false"
            class="alert alert-warning"
          >
            Не удалось сбросить пароль. Повторите попытку позже или обратитесь к администратору.
          </div>
        </div>
        <div
          v-if="isResetCodeVerified !== false"
          class="auth-screen__middle"
        >
          <form
            class="auth-form"
            @submit.prevent="changePassword"
          >
            <b-form-group label="Пожалуйста, придумайте новый пароль">
              <b-form-input
                id="password"
                v-model="password"
                type="password"
                :state="validation.password.state"
              >
              </b-form-input>
              <b-form-invalid-feedback id="password-feedback">
                {{ validation.password.error }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Подтвердите пароль">
              <b-form-input
                id="confirm-password"
                v-model="confirmPassword"
                type="password"
                :state="validation.confirmPassword.state"
              >
              </b-form-input>
              <b-form-invalid-feedback id="confirm-password-feedback">
                {{ validation.confirmPassword.error }}
              </b-form-invalid-feedback>
            </b-form-group>
            <password-rules></password-rules>
            <div class="auth-form__button mt-4">
              <button
                type="submit"
                class="btn btn-primary btn-block"
                :disabled="!isResetCodeVerified || processing"
              >
                Сохранить
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="auth-banner">
        <img
          class="auth-banner__img"
          src="@/assets/banner.png"
        />
      </div>
      <warning />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Warning from '@/components/sign-in/AuthWarning.vue';
import PasswordRules from '@/components/users/PasswordRules';

export default {
  name: 'PasswordReset',

  components: {
    Warning,
    PasswordRules,
  },

  props: {
    resetCode: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isResetCodeVerified: null,
      processing: false,
      password: '',
      confirmPassword: '',
      validation: {
        password: { error: '', state: null },
        confirmPassword: { error: '', state: null },
      },
    };
  },

  computed: {
    ...mapState(['user']),
  },

  created() {
    if (this.resetCode) {
      this.$store.commit('logOut');
      setTimeout(() => {
        this.verifyResetCode();
      }, 100);
    }
  },

  methods: {
    async verifyResetCode() {
      this.processing = true;
      this.$store.commit('logOut');

      try {
        await this.$http.post('users/1.0/token-validate', {
          token: this.resetCode,
        });
        this.isResetCodeVerified = true;
      } catch (error) {
        this.isResetCodeVerified = false;
      } finally {
        this.processing = false;
      }
    },
    validateForm() {
      Object.assign(this.$data.validation, this.$options.data().validation);

      let isFormValid = true;

      if (this.password && this.password.length < 12) {
        this.validation.password.error = 'Длина пароля менее 12 символов';
        this.validation.password.state = false;
        isFormValid = false;
      }

      if (!this.password) {
        this.validation.password.error = 'Необходимо заполнить поле';
        this.validation.password.state = false;
        isFormValid = false;
      }

      if (!this.confirmPassword) {
        this.validation.confirmPassword.error = 'Необходимо заполнить поле';
        this.validation.confirmPassword.state = false;
        isFormValid = false;
      }

      if (this.password !== this.confirmPassword) {
        this.validation.confirmPassword.error = 'Пароль и подтверждение не совпадают';
        this.validation.confirmPassword.state = false;
        isFormValid = false;
      }

      return isFormValid;
    },
    async changePassword() {
      if (this.validateForm()) {
        this.processing = true;
        try {
          await this.$http.post('users/1.0/set-password', {
            password: this.password,
          });
          this.$router.push('/user-list');
        } finally {
          this.processing = false;
        }
      }
    },
  },
};
</script>
